import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChart6"><Path d="M23 21V19H21.0098V3.00098H16.3398V19H14.3399V8.50098H9.66992V19H7.67V14.001H3V19H1V21H23Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart6;
